<template>
  <div v-editable="blok" class="rectangle">
    <StoryblokComponent
      v-for="childBlok in blok.label"
      :key="childBlok._uid"
      class="rectangle__label"
      :blok="childBlok"
    />
    <BaseLink
      v-editable="blok"
      class="rectangle__link"
      :address="blok.link"
      target="_blank"
    >
      {{ blok.link_text }}
    </BaseLink>
  </div>
</template>

<script lang="ts" setup>
import type { SbRectangleLinkStoryblok } from '@/types'
interface Props {
  blok: SbRectangleLinkStoryblok
}
defineProps<Props>()
</script>
<style lang="scss" scoped>
.rectangle {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: -1px;
  border: 1px solid var(--gray-300);
  border-radius: var(--border-radius-small);
  padding: 12px 24px;
  flex-direction: column;

  @media (min-width: $breakpoint-md) {
    flex-direction: row;
    align-items: center;
  }

  &__label {
    @include heading-subheading;

    margin: 0;
    margin-bottom: 8px;
    text-transform: uppercase;

    @media (min-width: $breakpoint-md) {
      margin-bottom: 0;
    }
  }

  &__link {
    @include paragraph-s;
  }
}
</style>
